(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    (() => {
    const showSuccess = (region) => {
      region.textContent = '';
      setTimeout(() => {
        const message = document.createElement('div');
        message.className = 'alert bg-success-bg text-success-text mt-2 mb-2';
        message.textContent = region.dataset.successMessage;
        region.appendChild(message);
      }, 100);
    };

    document.querySelectorAll('[role="status"][data-posted]').forEach((region) => {
      setTimeout(() => showSuccess(region), 400);
    });

    if (!window.fetch || !window.FormData) return;

    const nativeSubmit = HTMLFormElement.prototype.submit;

    HTMLFormElement.prototype.submit = function () {
      const form = this;
      const region = form.querySelector && form.querySelector('[role="status"][id$="-success"][data-success-message]');

      if (!region) return nativeSubmit.apply(form, arguments);
      if (form.dataset.submitting) return;

      if (form.dataset.nativeFallback) {
        delete form.dataset.nativeFallback;
        return nativeSubmit.apply(form, arguments);
      }

      const retryNatively = () => {
        delete form.dataset.submitting;
        form.dataset.nativeFallback = 'true';
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          nativeSubmit.call(form);
        }
      };

      form.dataset.submitting = 'true';

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin'
      })
        .then((response) => {
          if (response.ok && /[?&]customer_posted=true/.test(response.url)) {
            const input = form.querySelector('input[name="contact[email]"]');
            if (input) {
              input.value = '';
              input.removeAttribute('aria-invalid');
            }
            delete form.dataset.submitting;
            showSuccess(region);
          } else {
            retryNatively();
          }
        })
        .catch(retryNatively);
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
